import axios from 'axios';
const baseURL = "https://www.unco.edu/marketing-communications/brand-tools/email-signature/data";


const getDisclaimers = () => {

    const request = axios.get(`${baseURL}/disclaimers.json`);
    return request.then(response => response.data);

}

const getLogos = () => {
    const request = axios.get(`${baseURL}/logos.json`);
    return request.then(response => response.data);
}

export default { getDisclaimers, getLogos }